module.exports = __webpack_public_path__ + "static/media/fruits2.c492d8ee.jpg";